import { useState, useEffect } from 'react';

export const useInstallPrompt = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [isIOS, setIsIOS] = useState(false);

    useEffect(() => {
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches
            || window.navigator.standalone;

        if (isStandalone) return;

        const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
        if (!isMobile) return;

        const isIOSDevice = /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase())
            && !window.MSStream;

        if (isIOSDevice) {
            setIsIOS(true);
            setIsOpen(true);
            return;
        }

        const open = (e) => {
            setDeferredPrompt(e);
            setIsOpen(true);
        };

        const stored = window.__pwaDeferredPrompt;
        if (stored) {
            open(stored);
            window.__pwaDeferredPrompt = null;
            return;
        }

        const handler = (e) => {
            e.preventDefault();
            open(e);
        };

        window.addEventListener('beforeinstallprompt', handler);

        return () => {
            window.removeEventListener('beforeinstallprompt', handler);
        };
    }, []);

    const handleInstall = async () => {
        if (isIOS) {
            setIsOpen(false);
            return;
        }
        if (!deferredPrompt) return;
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        if (outcome === 'accepted') {
            setDeferredPrompt(null);
        }
        setIsOpen(false);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    return { isOpen, handleInstall, handleClose, isIOS };
};
